'use client';

import React from 'react';

import { CustomRadio, HiddenRadio, RadioWrapper } from './styles';

export interface RadioButtonProps {
  id: string;
  name: string;
  value: string;
  checked: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

/**
 * A styled radio button component.
 */
export const RadioButton = ({ id, name, value, checked, onChange }: RadioButtonProps) => {
  return (
    <RadioWrapper>
      <HiddenRadio
        id={id}
        name={name}
        value={value}
        checked={checked}
        onChange={onChange}
        required
      />
      <CustomRadio />
    </RadioWrapper>
  );
};
